import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PushApplicationState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';


export const state: PushApplicationState = {
  pushApplications: [],
  pushApplication: undefined,
  pushOS: ['Android','iOS'],
  pushOSVersions: [],
  pushSDKVersions: [],
  pushMappVersions: [],
  pushFilters: []
};

export const pushApplication: Module<PushApplicationState, RootState> = {
  state,
  getters,
  actions,
  mutations
};